<template>
	<div :class="{'page7': this.vipState === 0 || this.vipState === 'loginNo'}">
		<div class="jobAnalysis" :class="{'new-job-analy': vipState === 0 || vipState === 'loginNo'}">
			<!-- 过期会员显示 -->
			<div v-if="vipState===2">
				<div class="jobAnalysis-no"></div>
				<div class="jobAnalysis-btn-wrap" @click="showDialog">
					<span class="jobAnaly-buy">开通会员查看数据分析</span>
				</div>
			</div>
			<!-- 新版非会员显示 -->
			<div class="newV-jobAnalysis-no" v-else-if="vipState==='loginNo' || vipState===0">
				<div class="title">
					<div class="analy-title">了解职场竞争力，求职分析帮助你</div>
					<div class="analy-desc">简历石沉大海，原因究竟出在哪里？</div>
				</div>
				<div class="demo-img"></div>
				<div class="buy-vip-text">
					<p class="text-line">开通正式版会员</p>
					<p class="text-line">查看完整竞争力，查缺补漏，求职路上不迷茫</p>
				</div>
				<div class="jobAnalysis-btn-wrap" :class="{'newV-jobAnalysis-btn-wrap': vipState==='loginNo' || this.vipState === 0}"  v-if="vipState==='loginNo' || this.vipState === 0" @click="showDialog">
					<p class="btn-text" v-if="vipState==='loginNo' || !(cvipMes.cvipstate==1 || cvipMes.cvipstate==10)" @click="showDialog">马上开始求职指导</p>
				</div>
			</div>
			<!-- 会员显示求职分析 -->
			<div class="jobAnalysis-out" v-else>
				<p class="jobAnalysis-tit">求职分析</p>
				<p class="jobAnalysis-des">专属求职分析，让你在求职路上不走弯路！</p>
				<!-- <div><img class="jobAnaly-bg" src="../../../../assets/imgs/jobAnaly-bg.png"></div> -->
				<div class="jobAnalysis-con">
					<ul  class="jobAnalysis-alldes clearfix">
						<li  class="jobAnalysis-alldes-scors fl">
							<span class="jobAnalysis-alldes-scorsTit">— 综合竞争力 —</span>
							<p class="jobAnalysis-alldes-scorsSum">
								<span class="fontW">{{cvipMes.advice.score}}</span>
								<span class="jobAnalysis-alldes-scorsSumIn">分</span>
							</p>
							<p class="jobAnalysis-alldes-scorsBeat">击败了{{cvipMes.advice.exceedPercent}}%的求职者</p>
						</li>
						<li class="jobAnalysis-alldes-per fl">
							<p class="jobAnalysis-alldes-perSum">
								<span class="fontW">{{cvipMes.advice.resumeAnalysisResult.resumeCompleteRate}}</span>
								<span class="jobAnalysis-alldes-perSumIn">%</span>
							</p>
							<p class="jobAnalysis-alldes-perTit">简历完善度</p>
							<p class="jobAnalysis-alldes-perDes">
								<span>{{cvipMes.advice.resumeAnalysisResult.resumeAdvice}}</span>
							</p>
							<a class="jobAnalysis-alldes-perBtn"
								:href="cvipMes.advice.resumeAnalysisResult.resumeLink"
								onclick="clickLog('from=pc-cvip-qzfx-jlws-wsjl-hy');"
								v-text="cvipMes.haveResume ? '完善简历' : '创建简历'"
								target="_blank"></a>
						</li>
						<li class="jobAnalysis-alldes-per fl">
							<p class="jobAnalysis-alldes-perSum">
								<span class="fontW">{{cvipMes.advice.yesterdayDeliveryAnalysisResult.yesterdayDeliveryCount}}</span>
								<span class="jobAnalysis-alldes-perSumIn">次</span>
							</p>
							<p class="jobAnalysis-alldes-perTit">昨日投递量</p>
							<p class="jobAnalysis-alldes-perDes" :title="cvipMes.advice.yesterdayDeliveryAnalysisResult.deliveryAdvice">
								<span>{{cvipMes.advice.yesterdayDeliveryAnalysisResult.deliveryAdvice}}</span>
							</p>
							<a class="jobAnalysis-alldes-perBtn"
								:href="cvipMes.advice.yesterdayDeliveryAnalysisResult.deliveryLink"
								onclick="clickLog('from=pc-cvip-qzfx-tdl-mstd-hy');"
								v-text="cvipMes.haveResume ? '马上投递' : '创建简历'"
								target="_blank"></a>
						</li>
						<li class="jobAnalysis-alldes-pri fl">
							<!-- <p class="jobAnalysis-alldes-priSum">{{cvipMes.advice.resourceUsedResult.usedCount}}/{{cvipMes.advice.resourceUsedResult.totalCount}}</p> -->
							<!-- <p class="jobAnalysis-alldes-priSum">{{usedCount}}/6</p> -->
							<p class="jobAnalysis-alldes-priSum"><span class="fontW">{{getUsedCount}}/5</span></p>
							<p class="jobAnalysis-alldes-priTit">特权使用情况</p>
							<div class="jobAnalysis-alldes-priConOut">
								<ul class="jobAnalysis-alldes-priCon clearfix" v-show="priUseIndex<=0">
									<li class="jobAnalysis-alldes-priConIn fl">
										<dl class="jobAnalysis-alldes-priAll">
											<dt><span class="jobAnalysis-alldes-priAllImg jobAnalysis-alldes-zgbs"></span></dt>
											<dd>
												<p class="jobAnalysis-alldes-priAllTit">尊贵标识</p>
												<span class="jobAnalysis-alldes-priAllBtn" v-if="cvipMes.cvipstate===0 || cvipMes.cvipstate===2">立即使用</span>
												<span class="jobAnalysis-alldes-priAllBtn jobAnalysis-alldes-priAllBtnUse" v-else-if="(cvipMes.cvipstate===1||cvipMes.cvipstate===10) && rightUsed[10]">已使用</span>
												<span class="jobAnalysis-alldes-priAllBtn" v-else-if="(cvipMes.cvipstate===1||cvipMes.cvipstate===10) && !rightUsed[10]">立即使用</span>
											</dd>
										</dl>
									</li>
									<li class="jobAnalysis-alldes-priConIn fl">
										<dl class="jobAnalysis-alldes-priAll">
											<dt><span class="jobAnalysis-alldes-priAllImg jobAnalysis-alldes-wxsx"></span></dt>
											<dd>
												<p class="jobAnalysis-alldes-priAllTit">免费刷新</p>
												<span class="jobAnalysis-alldes-priAllBtn" v-if="cvipMes.cvipstate===0 || cvipMes.cvipstate===2">立即使用</span>
												<span class="jobAnalysis-alldes-priAllBtn jobAnalysis-alldes-priAllBtnUse" v-else-if="(cvipMes.cvipstate===1||cvipMes.cvipstate===10) && rightUsed[13]">已使用</span>
												<span class="jobAnalysis-alldes-priAllBtn" v-else-if="(cvipMes.cvipstate===1||cvipMes.cvipstate===10) && !rightUsed[13]">立即使用</span>
											</dd>
										</dl>
									</li>
									<li class="jobAnalysis-alldes-priConIn fl jobAnalysis-alldes-priConInR">
										<dl class="jobAnalysis-alldes-priAll">
											<dt><span class="jobAnalysis-alldes-priAllImg jobAnalysis-alldes-qzfx"></span></dt>
											<dd>
												<p class="jobAnalysis-alldes-priAllTit">求职分析</p>
												<span class="jobAnalysis-alldes-priAllBtn" v-if="cvipMes.cvipstate===0 || cvipMes.cvipstate===2">立即使用</span>
												<span class="jobAnalysis-alldes-priAllBtn jobAnalysis-alldes-priAllBtnUse" v-else-if="(cvipMes.cvipstate===1||cvipMes.cvipstate===10) && rightUsed[12]">已使用</span>
												<span class="jobAnalysis-alldes-priAllBtn" v-else-if="(cvipMes.cvipstate===1||cvipMes.cvipstate===10) && !rightUsed[12]">立即使用</span>
											</dd>
										</dl>
									</li>
								</ul>
								<ul class="jobAnalysis-alldes-priCon clearfix" v-show="priUseIndex>0">
									<li class="jobAnalysis-alldes-priConIn fl">
										<dl class="jobAnalysis-alldes-priAll">
											<dt><span class="jobAnalysis-alldes-priAllImg jobAnalysis-alldes-jlzd"></span></dt>
											<dd>
												<p class="jobAnalysis-alldes-priAllTit">简历置顶</p>
												<span class="jobAnalysis-alldes-priAllBtn" v-if="cvipMes.cvipstate===0 || cvipMes.cvipstate===2">立即使用</span>
												<span class="jobAnalysis-alldes-priAllBtn jobAnalysis-alldes-priAllBtnUse" v-else-if="(cvipMes.cvipstate===1||cvipMes.cvipstate===10) && rightUsed[5]">已使用</span>
												<span class="jobAnalysis-alldes-priAllBtn"
													v-else-if="(cvipMes.cvipstate===1||cvipMes.cvipstate===10) && !rightUsed[5]"
													@click.stop="topResume"
													v-text="resumeListNum ? '立即置顶' : '创建简历'"></span>
											</dd>
										</dl>
									</li>
									<!-- <li class="jobAnalysis-alldes-priConIn fl">
										<dl class="jobAnalysis-alldes-priAll">
											<dt><span class="jobAnalysis-alldes-priAllImg jobAnalysis-alldes-grrz"></span></dt>
											<dd>
												<p class="jobAnalysis-alldes-priAllTit">个人认证</p>
												<span class="jobAnalysis-alldes-priAllBtn" v-if="cvipMes.cvipstate===0 || cvipMes.cvipstate===2">立即使用</span>
												<span class="jobAnalysis-alldes-priAllBtn jobAnalysis-alldes-priAllBtnUse" v-else-if="(cvipMes.cvipstate===1||cvipMes.cvipstate===10) && rightUsed[11]">已使用</span>
												<span class="jobAnalysis-alldes-priAllBtn" v-else-if="(cvipMes.cvipstate===1||cvipMes.cvipstate===10) && !rightUsed[11]" @click.stop="certification">立即认证</span>
											</dd>
										</dl>
									</li> -->
									<li class="jobAnalysis-alldes-priConIn fl jobAnalysis-alldes-priConInR">
										<dl class="jobAnalysis-alldes-priAll">
											<dt><span class="jobAnalysis-alldes-priAllImg jobAnalysis-alldes-hjld"></span></dt>
											<dd>
												<p class="jobAnalysis-alldes-priAllTit">黄金亮点</p>
												<span class="jobAnalysis-alldes-priAllBtn" v-if="cvipMes.cvipstate===0 || cvipMes.cvipstate===2">立即使用</span>
												<span class="jobAnalysis-alldes-priAllBtn jobAnalysis-alldes-priAllBtnUse" v-else-if="(cvipMes.cvipstate===1||cvipMes.cvipstate===10) && rightUsed[4]">已使用</span>
												<span class="jobAnalysis-alldes-priAllBtn"
													v-else-if="(cvipMes.cvipstate===1||cvipMes.cvipstate===10) && !rightUsed[4]"
													@click.stop="hightResume"
													v-text="resumeListNum ? '选择亮点' : '创建简历'"></span>
											</dd>
										</dl>
									</li>
								</ul>
								<span class="jobAnalysis-alldes-priL" @click="priShow('l')"></span>
								<span class="jobAnalysis-alldes-priR" @click="priShow('r')"></span>
							</div>
						</li>
					</ul>
				</div>
				<resume-chart></resume-chart>
			</div>
			<resume-top-dialog v-if="showTop" @closeDialog='closeDialog' @topBtnChange='topBtnChange' @show-alert="showAlert"></resume-top-dialog>
			<!-- <gold-light-dialog v-if="showLight" @closeDialog='closeDialog' @lightBtnChange='lightBtnChange' @show-alert="showAlert"></gold-light-dialog> -->
			<!-- 成功 alert -->
			<cvip-alert v-if="showSuccess"
			@on-hide="onHide"
			buttonTxt="我知道了"
			widthnew='450px'
			heightnew='200px'
			marginnew='-100px auto'>
			<span class="alert-icon icon-success"></span>
			<span>{{alertTxt}}</span>
			</cvip-alert>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ResumeTopDialog from '../dialog/ResumeTopDialog.vue'
import GoldLightDialog from '../dialog/GoldLightDialog.vue'
import ResumeChart from '../jobAnalysis/resumeChart/ResumeChart.vue'
import CvipAlert from "../../../../components/alert/Alert"
export default {
	name: 'jobAnalysis',
	components:{
		ResumeChart,
		ResumeTopDialog,
		GoldLightDialog,
		CvipAlert
	},
	props: ['vipState'],
	data () {
		return {
			priUseIndex: 0,
			showTop: false, //简历置顶弹窗
			showLight: false, //亮点设置弹窗
			alertTxt: '',  // 成功 alert 弹框内容
			showSuccess: false // 成功 alert 弹框标志
		}
	},
	mounted() { },
	methods: {
		showDialog () {
			this.$emit('showDialog')
			window.clickLog && window.clickLog(`from=pc-cvip-qiuzhifenxi-ljkt${this.vipState}`)
		},
		priShow (type) {
			this.priUseIndex = this.priUseIndex ? 0 : 1
		},
		certification () {
			window.open("//my.58.com/pro/jianlicert/")
			window.clickLog && window.clickLog('from=pc-cvip-qzfx-grrz-sy-hy')
		},
		hightResume () {
			this.closeDialog()
			if (!this.resumeListNum) {
				window.open("//jianli.58.com/resumepost/view/fulltime/")
        		return
			}
			this.showLight = true
			window.clickLog && window.clickLog('from=pc-cvip-qzfx-hjbq-sy-hy')
		},
		topResume () {
			this.closeDialog()
			if (!this.resumeListNum) {
				window.open("//jianli.58.com/resumepost/view/fulltime/")
        		return
			}
			this.showTop = true
			window.clickLog && window.clickLog('from=pc-cvip-qzfx-jlzd-sy-hy')
		},
		closeDialog () {
			this.showTop = false
			this.showLight = false
		},
		lightBtnChange () {
			this.$store.commit('RIGHT_USED', {
				'4': true
			})
		},
		topBtnChange () {
			this.$store.commit('RIGHT_USED', {
				'5': true
			})
		},
		showAlert (txt) {
			this.alertTxt = txt
			setTimeout(() => {
				this.showSuccess = true
			}, 500)
		},
		onHide () {
			this.showSuccess = false
		}
	},
	computed: {
		...mapGetters({
			cvipMes: 'cvipMes',
			rightUsed: 'rightUsed', //4：黄金亮点 5：置顶 10：尊贵标识 11：个人认证 12：求职分析 13：免费刷新 14：求职保障 15：意外保险
			resumeListNum: 'resumeListNum'
		}),
		/**
		 * 获取权限使用个数
		 * 遇到的坑：未把需要监控的变量添加到 state 中，未生成相应的 setter、getter 方法导致实时更新失败
     	 */
		getUsedCount () {
			let res = 0
			for (let i in this.rightUsed) {
				if (+i < 14 && this.rightUsed[i]) {
					res++
				}
			}
			return res
		}
	}
}
</script>

<style lang="scss" scope>
	.page7{
		height: 100%;
		width: 100%;
		position: relative;
		background: url(../../../../assets/imgs/bg-page5.png) no-repeat center;
		background-size: 100% 100%;
	}
	.jobAnalysis {
		// z-index: 0;
		position: relative;
		width: 100%;
		background: #F6F6F6;
		.fontW {
			font-weight: 600;
		}
	}
	.jobAnalysis-out {
		position: relative;
		width: 1190px;
		margin: 0 auto;
		padding: 70px 0;
	}
	.jobAnalysis-layer {
		z-index: 999;
		position: absolute;
		//top: 170px;
		left: 0;
		width: 100%;
		height: 812px;
		opacity: 0.9;
		//background-image: linear-gradient(-180deg, rgba(255,255,255,0.72) 0%, #F6F6F6 50%);
		background: url(../../../../assets/imgs/jobAnaly-no.png?1) no-repeat;
		background-size: 100% 812px;
	}


	// 新版非会员样式
	.new-job-analy{
		width: 1190px;
		height: 700px;
		position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
		background: transparent;
	}

	.jobAnalysis-no{
		margin: 0 auto;
		width: 1190px;
		height: 812px;
		background: url(../../../../assets/imgs/jobAnaly-no.png?1) no-repeat;
		background-size: 100% 812px;
	}

	// 新版非会员样式
	.newV-jobAnalysis-no {
		width: 1190px;
		height: 645px;
		margin: 50px auto;
		//新版非会员样式
		.title {
			.analy-title {
				font-size: 44px;
				color: #FFFFFF;
				letter-spacing: 0;
				text-align: center;
			}
			.analy-desc {
				opacity: 0.5;
				font-size: 20px;
				color: #FFFFFF;
				text-align: center;
				margin-top: 20px;
			}
		}
		.demo-img{
			width: 100%;
			height: 560px;
			margin-top: 40px;
			background: url(../../../../assets/imgs/jobAnaly-demo.png?1);
			background-size: 100% 100%;
		}
		.buy-vip-text{
			width: 576px;
			height: 80px;
			font-family: PingFangSC-Regular;
			font-size: 18px;
			color: #E6CA99;
			letter-spacing: 0;
			text-align: center;
			line-height: 40px;
			position: absolute;
			margin: 0 auto;
			left: 0;
			right: 0;
			top: 490px;
			.text-line{
				text-align: center;
				line-height: 30px;
			}
		}
	}
	.jobAnalysis-tit {
		margin-bottom: 12px;
		height: 36px;
		line-height: 36px;
		font-size: 36px;
		font-weight: 600;
		color: #000;
		text-align: center;
	}
	.jobAnalysis-des {
		margin-bottom: 28px;
		height: 25px;
		line-height: 25px;
		font-size: 18px;
		color: #aaa;
		text-align: center;
	}
	.jobAnaly-bg {
		width: 1200px;
		margin: 0 auto;
	}
	.jobAnalysis-btn-wrap {
		overflow: hidden;
		position: absolute;
		bottom: 90px;
		left: 0;
		right: 0;
		margin: 0 auto;
		width: 212px;
		height: 50px;
		line-height: 50px;
		border-radius: 100px;
		z-index: 1000;
	}
	// 新版非会员按钮购买样式
	.newV-jobAnalysis-btn-wrap{
		width: 428px;
		height: 95px;
		bottom: 20px;
		margin: 0 auto;
		background: url(../../../../assets/imgs/buybtn.png) no-repeat center;
		background-size: 100% 100%;
		cursor: pointer;
		&:hover {
			background: url(../../../../assets/imgs/buybtn-hover.png) no-repeat center;
			background-size: 100% 100%;
		}
		.btn-text{
			height: 50px;
			line-height: 50px;
			padding-top: 14px;
			font-weight: bold;
			font-size: 16px;
			color: #403C36;
			letter-spacing: 0;
			text-align: center;
			text-shadow: 0 1px 0 rgba(255,255,255,0.22);
		}
	}
	.jobAnaly-buy {
		display: block;
		font-size: 16px;
		color: #fff;
		filter: progid:DXImageTransform.Microsoft.Gradient(startColorStr='#3B3529',endColorStr='#49402D',gradientType='0');
		background-image: -webkit-linear-gradient(-27deg, #3B3529 0%, #49402D 52%, #49402D 100%);
		background-image: -o-linear-gradient(-27deg, #3B3529 0%, #49402D 52%, #49402D 100%);
		background-image: -moz-linear-gradient(-27deg, #3B3529 0%, #49402D 52%, #49402D 100%);
		background-image: linear-gradient(-27deg, #3B3529 0%, #49402D 52%, #49402D 100%);
		text-align: center;
		cursor: pointer;
		&:hover {
			opacity: .9;
		}
	}
	.jobAnalysis-alldes-scors {
		margin-right: 10px;
		padding-top: 30px;
		width: 320px;
		height: 170px;
		filter: progid:DXImageTransform.Microsoft.Gradient(startColorStr='#26231D',endColorStr='#201C16',gradientType='0');
		background-image: -webkit-linear-gradient(-27deg, #26231D 0%, #43403B 52%, #201C16 100%);
		background-image: -o-linear-gradient(-27deg, #26231D 0%, #43403B 52%, #201C16 100%);
		background-image: -moz-linear-gradient(-27deg, #26231D 0%, #43403B 52%, #201C16 100%);
		background-image: linear-gradient(-27deg, #26231D 0%, #43403B 52%, #201C16 100%);
		text-align: center;
	}
	.jobAnalysis-alldes-scorsTit {
		display: block;
		margin-bottom: 34px;
		opacity: 0.7;
		font-family: PingFangSC-Regular;
		font-size: 14px;
		color: #fff;
		line-height: 14px;
	}
	.jobAnalysis-alldes-scorsSum {
		margin-bottom: 22px;
		font-size: 50px;
		color: #D4B277;
		line-height: 40px;
		span {
			margin: -6px;
		}
	}
	.jobAnalysis-alldes-scorsSumIn {
		font-size: 20px;
		line-height: 40px;
	}
	.jobAnalysis-alldes-scorsBeat {
		font-size: 14px;
		color: #D4B277;
		line-height: 14px;
	}
	.jobAnalysis-alldes-per {
		margin-right: 10px;
		padding-top: 30px;
		width: 260px;
		height: 170px;
		background: #FFFFFF;
		text-align: center;
	}
	.jobAnalysis-alldes-perSum {
		margin-bottom: 7px;
		font-size: 26px;
		color: #3F3C37;
		line-height: 30px;
		span {
			margin: -3px;
		}
	}
	.jobAnalysis-alldes-perSumIn {
		font-size: 14px;
		color: #3F3C37;
		line-height: 20px;
	}
	.jobAnalysis-alldes-perTit {
		margin-bottom: 22px;
		font-size: 12px;
		color: #555;
		line-height: 14px;
	}
	.jobAnalysis-alldes-perDes {
		display: table-cell;
		padding-bottom: 20px;
		width: 260px;
		height: 32px;
		// line-height: 16px;
		opacity: 0.7;
		font-size: 12px;
		color: #999;
		vertical-align: bottom;
		// overflow: hidden;
		// text-overflow: ellipsis;
		// white-space: nowrap;
		span {
			display: block;
			margin: 0 auto;
			width: 200px;
		}
	}
	.jobAnalysis-alldes-perBtn {
		display: block;
		margin: 0 auto;
		width: 90px;
		height: 26px;
		line-height: 26px;
		border: 1px solid #DEC499;
		border-radius: 100px;
		font-size: 12px;
		color: #B89860;
		cursor: pointer;
		&:hover {
			filter: progid:DXImageTransform.Microsoft.Gradient(startColorStr='#D2AF74',endColorStr='#FCCB78',gradientType='0');
			background-image: -webkit-linear-gradient(-140deg, #D2AF74 0%, #FCCB78 100%);
			background-image: -o-linear-gradient(-140deg, #D2AF74 0%, #FCCB78 100%);
			background-image: -moz-linear-gradient(-140deg, #D2AF74 0%, #FCCB78 100%);
			background-image: linear-gradient(-140deg, #D2AF74 0%, #FCCB78 100%);
			color: #fff;
			opacity: .9;
		}
	}
	.jobAnalysis-alldes-pri {
		overflow: hidden;
		padding-top: 30px;
		width: 320px;
		height: 170px;
		background: #fff;
		text-align: center;
	}
	.jobAnalysis-alldes-priSum {
		margin-bottom: 4px;
		font-size: 26px;
		color: #3F3C37;
		line-height: 30px;
	}
	.jobAnalysis-alldes-priTit {
		margin-bottom: 18px;
		font-size: 12px;
		color: #555;
		line-height: 14px;
	}
	.jobAnalysis-alldes-priCon {
		padding: 0 30px;
		margin-bottom: 20px;
	}
	.jobAnalysis-alldes-priConOut {
		position: relative;
	}
	.jobAnalysis-alldes-priConIn {
		margin-right: 20px;
	}
	.jobAnalysis-alldes-priAllImg {
		display: block;
		margin: 0 auto 9px;
		width: 26px;
		height: 26px;
	}
	.jobAnalysis-alldes-grrz {
		background: url(../../../../assets/imgs/jobAnaly-grrz.png);
		background-size: 100%;
	}
	.jobAnalysis-alldes-zgbs {
		background: url(../../../../assets/imgs/jobAnaly-zgbs.png);
		background-size: 100%;
	}
	.jobAnalysis-alldes-wxsx {
		background: url(../../../../assets/imgs/jobAnaly-wxsx.png);
		background-size: 100%;
	}
	.jobAnalysis-alldes-qzfx {
		background: url(../../../../assets/imgs/jobAnaly-qzfx.png);
		background-size: 100%;
	}
	.jobAnalysis-alldes-jlzd {
		background: url(../../../../assets/imgs/jobAnaly-jlzd.png);
		background-size: 100%;
	}
	.jobAnalysis-alldes-hjld {
		background: url(../../../../assets/imgs/jobAnaly-hjld.png);
		background-size: 100%;
	}
	.jobAnalysis-alldes-priAllTit {
		margin-bottom: 10px;
		font-size: 12px;
		color: #333;
		line-height: 16px;
	}
	.jobAnalysis-alldes-priAllBtn {
		display: block;
		margin: 0 auto;
		width: 70px;
		height: 26px;
		line-height: 26px;
		border: 1px solid #DEC499;
		border-radius: 100px;
		font-size: 12px;
		color: #B89860;
		cursor: pointer;
		&:hover {
			filter: progid:DXImageTransform.Microsoft.Gradient(startColorStr='#D2AF74',endColorStr='#FCCB78',gradientType='0');
			background-image: -webkit-linear-gradient(-140deg, #D2AF74 0%, #FCCB78 100%);
			background-image: -o-linear-gradient(-140deg, #D2AF74 0%, #FCCB78 100%);
			background-image: -moz-linear-gradient(-140deg, #D2AF74 0%, #FCCB78 100%);
			background-image: linear-gradient(-140deg, #D2AF74 0%, #FCCB78 100%);
			color: #fff;
			opacity: .9;
		}
	}
	.jobAnalysis-alldes-priAllBtnUse {
		border: 1px solid #d8d8d8;
		color: #ccc;
		cursor: not-allowed;
		&:hover {
			filter: progid:DXImageTransform.Microsoft.Gradient(startColorStr='#fff',endColorStr='#fff',gradientType='1');
			background-image: none;
			color: #ccc;
		}
	}
	.jobAnalysis-alldes-priL {
		position: absolute;
		top: 14px;
		left: 17px;
		width: 8px;
		height: 14px;
		cursor: pointer;
		background: url(../../../../assets/imgs/pri-arrow-l.png) no-repeat;
		background-size: 100%;
		opacity: .5;
		&:hover {
			// background-color: #eee;
			opacity: .8;
		}
	}
	.jobAnalysis-alldes-priR {
		position: absolute;
		top: 14px;
		right: 17px;
		width: 8px;
		height: 14px;
		cursor: pointer;
		background: url(../../../../assets/imgs/pri-arrow-r.png) no-repeat;
		background-size: 100%;
		opacity: .5;
		&:hover {
			// background-color: #eee;
			opacity: .8;
		}
	}
	.jobAnalysis-alldes-priConInR {
		margin-right: 0;
	}
</style>



// WEBPACK FOOTER //
// JobAnalysis.vue?d003ff48